const textDecoder = new TextDecoder();

/**
 * An MQTT message body as text. mqtt.js hands payloads over as its own Buffer, a Uint8Array
 * underneath, so the platform decoder reads them without a Buffer polyfill.
 */
export function decodeMqttText(payload: Uint8Array): string {
    return textDecoder.decode(payload);
}
